import { jsonldGitHub } from './JsonldStore';

export const updateJsonldGitHub = (value) => jsonldGitHub.update((oldValue) => value);
